import { useCallback, useEffect, useState } from "react";
import { lazyWithPreload } from "utils/lazyWithPreload";

import { useLoggedInUser } from "hooks/useLoggedInUser";
import { usePreloadComponents } from "hooks/usePreloadedComponents";

type Options = {
  onOpen?: () => void;
};

const ContactSupport = lazyWithPreload(() => import("./ContactSupport"));

export const useContactSupport = (options?: Options) => {
  const onOpen = options?.onOpen;
  const [formOpen, setFormOpen] = useState<boolean>(false);
  const { isLoggedIn } = useLoggedInUser();

  usePreloadComponents([ContactSupport]);

  useEffect(() => {
    if (!isLoggedIn) {
      setFormOpen(false);
    }
  }, [isLoggedIn]);

  const openForm = useCallback(() => {
    onOpen?.();
    setFormOpen(true);
  }, [onOpen]);

  const closeForm = useCallback(() => {
    setFormOpen(false);
  }, []);

  const contactSupportMarkup = formOpen ? (
    <ContactSupport onClose={closeForm} />
  ) : null;

  return {
    openForm,
    closeForm,
    contactSupportMarkup,
  };
};
